import React from 'react';
import './index.scss'
import GoodsCard from "../../../../components/goods-card";

const GoodsFooter = props => {
    const {data,showGoodsListAction} = props;
    const {pdList = []} = data;
    const style = {
        marginBottom: data.margin_ + 'px'
    };
    return (
        <div style={style}>
            {
                pdList.map((data, index) => {
                    return (
                        <div className='goods-floor-box' key={index}>
                            {
                                data.map((goods, subIndex) => {
                                    return (
                                        goods ? (
                                            <GoodsCard
                                                key={subIndex}
                                                goods={goods}
                                                showGoodsListAction={showGoodsListAction}
                                            />
                                        ) : (
                                            <div style={{flex: 1}} key={subIndex}/>
                                        )
                                    )
                                })
                            }
                        </div>
                    )
                })
            }
        </div>
    )
};
export default GoodsFooter
